import { createRouter, createWebHistory } from 'vue-router'
import IndexPage from './components/IndexPage.vue'
import TaskPage from './components/TaskPage.vue'
import AccountPage from './components/AccountPage.vue'
import AddAccount from './components/AddAccount.vue'
import NotePage from './components/NotePage.vue'
import AdminHome from './admin/AdminHome.vue'
import UserAdmin from './admin/UserAdmin.vue'
import CKPachong from './admin/CKPachong.vue'
import PachongAdmin from './admin/PachongAdmin.vue'
import NoteAdmin from './admin/NoteAdmin.vue'
import TutorsAdmin from './admin/TutorsAdmin.vue'
import SucaiPage from './components/SucaiPage.vue'
import SucaiFiles from './components/SucaiFiles.vue'
import HomePage from './components/HomePage.vue'
import UserHome from './components/UserHome.vue'
import LoginPage from './components/LoginPage.vue'
import XHSQR from './components/XHSQR.vue'
import ProductPage from './components/ProductPage.vue'
import PaidSuc from './components/PaidSuc.vue'
import UserPromotion from './components/UserPromotion.vue'
import NoteDetail from './components/NoteDetail.vue'
import NewNote from './components/NewNote.vue'
import PreXuanti from './components/PreXuanti.vue'
import SetCookie from './components/SetCookie.vue'
import SaidaoDuibiao from './admin/SaidaoDuibiao.vue'


const routes = [
  { path: '/',  redirect: '/home'  },
  { path: '',  redirect: '/home'  },
  { path: '/admin',name:'admin', component:AdminHome, children:[
    { path: '',  redirect: '/admin/user'  },
    {path: 'user', component: UserAdmin},
    {path: 'newAccount/:user_id', component: AddAccount},
    {path: 'cks', component: PachongAdmin},
     {path: 'saidao', component: SaidaoDuibiao},
    {path: 'ck/:id', component: CKPachong},
    {path: 'note',name:'note', component: NoteAdmin,
  meta:{keepAlive:true}},
    {path: 'task/:id', component: TaskPage},
    {path: 'detail/:id', component: NoteDetail},
    {path: 'newn/:id', component: NewNote},
    {path: 'note/:id', component: NotePage},
    {path: 'usernotes/:id/:g_id', component: NotePage},
    {path: 'tutors', component: TutorsAdmin},
  ] },
  

  {path: '/qr/:id', component: XHSQR},
  { path: '/login', component: LoginPage },
  
  {path: '/home', component: HomePage},
 

  
  { path: '/index', component: IndexPage,children:[
    {path: 'user', component: UserHome,children:[
       {path: 'newAccount/:id', component: AddAccount},
      {path: 'account', component: AccountPage},
      {path: 'product/:id', component: ProductPage},
      {path: 'paid/:id', component: PaidSuc},
      {path: 'promotion', component: UserPromotion},
      {path: 'newAccount', component: AddAccount},
     
      {path: 'sucai', component: SucaiPage},
      {path: 'files/:id', component: SucaiFiles},
      {path: 'task/:id', component: TaskPage},
      {path: 'note/:id', component: NotePage},
    
      {path: 'detail/:id', component: NoteDetail},
      {path: 'newn/:id', component: NewNote},
      {path: 'prexuanti/:id', component: PreXuanti},
       {path: 'ck/:id', component: SetCookie},
      {path: 'usernotes', component: NotePage},

      {path: '', redirect:'/index/user/account'},
      {path: '/', redirect:'/index/user/account'},
    
      
    ]},
    {path: '/', component: HomePage},
    
   
   
    // {path: '/style/:id', component: StyleItem},
    // {path: '/style', component: StyleItem},
    // {path: '/users', component: UsersPage},
    // {path: '/photo', component: PhotosPage},
    // {path: '/task', component: TasksPage},
    // {path: '/order', component: OrdersPage},
    // {path: '/promotion', component: PromotionsPage},
    // {path: '/xhs', component: XHSPage},
  ] },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router